import { Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute, Layout } from '@/components'
import { Login } from '@/pages/auth/login'
import { Signup } from '@/pages/auth/signup'
import { Dashboard } from '@/pages/dashboard'
import { ParentCourses } from '@/pages/parent/courses'
import { ParentEnrollments } from '@/pages/parent/enrollments'
import { ParentPayments } from '@/pages/parent/payments'
import { ParentLeaderboard } from '@/pages/parent/leaderboard'
import { ParentRewards } from '@/pages/parent/rewards'
import { ParentCertificates } from '@/pages/parent/certificates'
import { ParentSettings } from '@/pages/parent/settings'
import { ParentProgress } from '@/pages/parent/progress'
import { ParentReports } from '@/pages/parent/reports'
import { ROUTES } from '@/constants'
import { UserRole } from '@/types'

export const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path={ROUTES.LOGIN} element={<Login />} />
      <Route path={ROUTES.REGISTER} element={<Signup />} />
      <Route path="/" element={<Navigate to={ROUTES.DASHBOARD} replace />} />

      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />

        {/* Admin Routes */}
        <Route
          path={ROUTES.ADMIN.DASHBOARD}
          element={
            <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.ADMIN.USERS}
          element={
            <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
              <div>Admin Users Page</div>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.ADMIN.STUDENTS}
          element={
            <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
              <div>Admin Students Page</div>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.ADMIN.TEACHERS}
          element={
            <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
              <div>Admin Teachers Page</div>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.ADMIN.CLASSES}
          element={
            <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
              <div>Admin Classes Page</div>
            </ProtectedRoute>
          }
        />

        {/* Teacher Routes */}
        <Route
          path={ROUTES.TEACHER.DASHBOARD}
          element={
            <ProtectedRoute allowedRoles={[UserRole.TEACHER]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.TEACHER.CLASSES}
          element={
            <ProtectedRoute allowedRoles={[UserRole.TEACHER]}>
              <div>Teacher Classes Page</div>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.TEACHER.STUDENTS}
          element={
            <ProtectedRoute allowedRoles={[UserRole.TEACHER]}>
              <div>Teacher Students Page</div>
            </ProtectedRoute>
          }
        />

        {/* Student Routes */}
        <Route
          path={ROUTES.STUDENT.DASHBOARD}
          element={
            <ProtectedRoute allowedRoles={[UserRole.STUDENT]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.STUDENT.CLASSES}
          element={
            <ProtectedRoute allowedRoles={[UserRole.STUDENT]}>
              <div>Student Classes Page</div>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.STUDENT.ASSIGNMENTS}
          element={
            <ProtectedRoute allowedRoles={[UserRole.STUDENT]}>
              <div>Student Assignments Page</div>
            </ProtectedRoute>
          }
        />

        {/* Parent Routes */}
        <Route
          path={ROUTES.PARENT.DASHBOARD}
          element={
            <ProtectedRoute allowedRoles={[UserRole.PARENT]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PARENT.COURSES}
          element={
            <ProtectedRoute allowedRoles={[UserRole.PARENT]}>
              <ParentCourses />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PARENT.ENROLLMENTS}
          element={
            <ProtectedRoute allowedRoles={[UserRole.PARENT]}>
              <ParentEnrollments />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PARENT.REWARDS}
          element={
            <ProtectedRoute allowedRoles={[UserRole.PARENT]}>
              <ParentRewards />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PARENT.PAYMENTS}
          element={
            <ProtectedRoute allowedRoles={[UserRole.PARENT]}>
              <ParentPayments />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PARENT.LEADERBOARD}
          element={
            <ProtectedRoute allowedRoles={[UserRole.PARENT]}>
              <ParentLeaderboard />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PARENT.CERTIFICATES}
          element={
            <ProtectedRoute allowedRoles={[UserRole.PARENT]}>
              <ParentCertificates />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PARENT.SETTINGS}
          element={
            <ProtectedRoute allowedRoles={[UserRole.PARENT]}>
              <ParentSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PARENT.CHILDREN}
          element={
            <ProtectedRoute allowedRoles={[UserRole.PARENT]}>
              <div>Parent Children Page</div>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PARENT.GRADES}
          element={
            <ProtectedRoute allowedRoles={[UserRole.PARENT]}>
              <div>Parent Grades Page</div>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PARENT.PROGRESS}
          element={
            <ProtectedRoute allowedRoles={[UserRole.PARENT]}>
              <ParentProgress />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PARENT.REPORTS}
          element={
            <ProtectedRoute allowedRoles={[UserRole.PARENT]}>
              <ParentReports />
            </ProtectedRoute>
          }
        />
      </Route>

      {/* 404 Route */}
      <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
    </Routes>
  )
}
